import React, { useContext, useEffect, useState } from 'react';
import {
  B1,
  getTranslatedText,
  Loader,
  AppContext,
  isAuthorised
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Avatar, Button, Heading, Link, Tag } from '@superops/ui-design-system';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { TempAccountClient, useQuery } from '@nile/graphql';
import { GET_CLIENT_USER } from '@nile/graphql/src/Query/client';
import { isEmpty } from 'lodash';

const InfoCardContainer = styled.div`
  min-width: 200px;
  border-radius: 10px;
  position: relative;
  .name_with_image {
    column-gap: 10px;
    .Superops-Avatar {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      top: 4px;
    }
    .name {
      font-weight: 600;
      font-size: 16px;
      line-height: 35px;
      line-break: anywhere;
    }
  }
  .email {
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.8);
    max-width: calc(100% - 35px);
    flex-wrap: wrap;
    line-break: anywhere;
  }
  .details {
    flex-wrap: wrap;
    gap: 10px;
    span {
      line-break: anywhere;
    }
  }
  svg,
  .icon {
    min-width: 30px;
    div {
      margin: auto;
    }
  }

  .phone-number {
    text-decoration: none;
  }
  .email-wrapper {
    min-height: 30px;
  }

  .copy-btn-wrapper {
    position: relative;

    .copied-tag {
      position: absolute;
      bottom: 30px;
      right: -10px;
    }

    .copy-btn {
      position: relative;
      top: 3px;
    }
  }
`;

const InfoCard = ({ data, intl, openRequesterModal, updatedRequester }) => {
  const [RequesterData, setRequesterData] = useState(data);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (updatedRequester) setRequesterData(updatedRequester);
  }, [updatedRequester]);

  const {
    email,
    firstName,
    lastName,
    name,
    forgotten,
    contactNumber,
    role
  } = RequesterData;
  const appContext = useContext(AppContext);
  const userRole = appContext?.user?.role?.roleFeatureList || [];
  const isRequesterEditAuthorised = isAuthorised(userRole, 'users.edit');
  const displayVal =
    firstName && lastName
      ? `${firstName} ${lastName}`
      : firstName
      ? firstName
      : name
      ? name
      : '';

  const { loading, error, data: userData, refetch } = useQuery(
    GET_CLIENT_USER,
    {
      variables: { userId: data?.userId, userCustomFields: false },
      client: TempAccountClient,
      onError() {},
      onCompleted: function(res) {
        const data = res?.getClientUser;
        setRequesterData(data);
      }
    }
  );

  const copyEmail = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  if (loading) return <Loader />;

  // if (error) return <div>error...</div>;

  const emailSplit = email?.split('@') || [];
  if (isEmpty(data)) return null;

  return (
    <InfoCardContainer>
      <div title={displayVal} className="fx name_with_image">
        <Avatar
          initials={displayVal.slice(0, 1).toUpperCase()}
          name={displayVal}
          size="extraSmall"
        />
        {isRequesterEditAuthorised && !forgotten ? (
          <div className="right ptr" onClick={openRequesterModal}>
            <Heading element="h3">
              <Link removeUnderline fontWeight="bolder">
                {displayVal || ' '}
              </Link>
            </Heading>
          </div>
        ) : (
          <div className="right">
            <Heading element="h3">
              <B1>{displayVal || ' '}</B1>
            </Heading>
          </div>
        )}
      </div>
      {emailSplit.length > 0 && (
        <span title={email} className="fx mt10 actr">
          <SVGIcon name="MailSettings" />
          <p className="email fx ml-10">
            <span>{emailSplit[0]}</span>
            <span>{`@${emailSplit[1]}`}</span>
          </p>
          <div className="mlauto">
            <div className="fx actr copy-btn-wrapper">
              {copied && (
                <div className="copied-tag">
                  <Tag>
                    {getTranslatedText(
                      intl,
                      'admin.customerSupportAccess.copied'
                    )}
                  </Tag>
                </div>
              )}
              <div className="copy-btn">
                <Button
                  className="pointer"
                  icon={<SVGIcon name="CopyClipboard" />}
                  onClick={copyEmail}
                  plain
                />
              </div>
            </div>
          </div>
        </span>
      )}

      {(contactNumber || role) && (
        <div className="details fx mt10">
          {role && (
            <span
              title={
                role?.name ||
                getTranslatedText(intl, 'ticket.list.requester.tblHeader')
              }
              className="fx"
            >
              <SVGIcon name="ProjectLogo" />
              <p className="ml-10">
                {role?.name || (
                  <FormattedMessage id="ticket.list.requester.tblHeader" />
                )}
              </p>
            </span>
          )}
          {contactNumber && (
            <span className="fx" title={contactNumber}>
              <SVGIcon name="Phone" />
              <a className="ml-10 phone-number" href={`tel:${contactNumber}`}>
                {contactNumber}
              </a>
            </span>
          )}
        </div>
      )}
    </InfoCardContainer>
  );
};

export default injectIntl(InfoCard);
